<template>
  <div class="main">
    <div class="header">
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/logo.png" alt="">
      <span>信息统计</span>
    </div>
    <div class="content">
      <el-tabs v-model="activeName">
        <el-tab-pane label="灵匠申请统计" name="first">
          <Jiang></Jiang>
        </el-tab-pane>
        <el-tab-pane label="用户咨询统计" name="second">
          <Consult></Consult>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Jiang from './component/jiang'
import Consult from './component/consult'

export default {
  name: 'UserLayout',
  data() {
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      format: 'yyyy-MM-dd HH:mm:ss',
      time: '',
      startDate: undefined,
      endDate: undefined,
      activeName: 'first'
    }
  },
  components: {
    Jiang,
    Consult
  },
  mounted () { 
  
  },
  methods: { },
  beforeDestroy () { }
}
</script>

<style lang="less" scoped>
.main{
  width: 100%;
  height: 100vh;
  background: #F7F7F7;
  .header{
    width: 100%;
    height: 111px;
    background: #FFFFFF;
    box-shadow: 0px 1px 11px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    align-items: center;
    img{
      height: 50px;
      margin-right: 10px;
    }
    span{
      font-size: 29px;
      font-weight: normal;
      color: #000000;
    }
  }
  .content{
    height: auto;
    padding: 20px;
    margin-top: 20px;
    background: #fff;
  }
}
.pagination{
  margin-top: 10px;
}
/deep/ .el-table .cell{
  line-height: normal;
  font-size: 20px;
}
.tableContent{
  margin-top: 20px;
}
</style>
<style>
  .el-date-table td span{
    font-size: 12px;
  }
  .el-picker-panel span{
    font-size: 12px;
  }
</style>
<style>
  #newBridge{
    display: none !important;
  }
</style>